<div class="p-dialog-header">
  <div class="p-d-flex p-dialog-title">
    <i class="pi pi-warning p-mr-2"></i>
    {{ title === "" ? ("SigvLibrary.SystemNotification" | translate) : title }}
  </div>
  <div class="p-dialog-header-icons">
    <button
      type="button"
      tabindex="-1"
      class="p-dialog-header-icon p-dialog-header-close p-link p-ripple"
      (click)="close()"
    >
      <span class="p-dialog-header-close-icon pi pi-close"></span
      ><span class="p-ink"></span>
    </button>
  </div>
</div>
<div class="p-dialog-content">
  <div class="p-grid">
    <div class="p-col-12" style="word-break: break-all;">
      <p-accordion
        [multiple]="true"
        expandIcon="pi pi-fw pi-collapse-open"
        collapseIcon="pi pi-fw pi-collapse-close"
      >
        <p-accordionTab header="Error Description" [selected]="false">
          {{error}}
        </p-accordionTab>
      </p-accordion>
    </div>
  </div>
</div>
<div class="p-dialog-footer">
  <div class="p-d-flex p-jc-center">
    <div class="button pv-0 ph-0">
      <a href="javascript: void(0)" class="btn btn-secondary" (click)="close()">
        {{ "Common.Button.Ok" | translate }}
      </a>
    </div>
  </div>
</div>
<div class="p-resizable-handle"></div>
